export const EASE = [0.16, 1, 0.3, 1];

export const VIEWPORT_40 = { once: true, margin: "-40px" };
export const VIEWPORT_60 = { once: true, margin: "-60px" };
export const VIEWPORT_80 = { once: true, margin: "-80px" };

export const fadeUp = {
  initial: { opacity: 0, y: 24 },
  whileInView: { opacity: 1, y: 0 },
  viewport: VIEWPORT_60,
  transition: { duration: 0.55, ease: EASE },
};

export const heroFadeUp = {
  initial: { opacity: 0, y: 30 },
  animate: { opacity: 1, y: 0 },
  transition: { duration: 0.7, ease: EASE },
};

export const heroScaleIn = {
  initial: { opacity: 0, scale: 0.95 },
  animate: { opacity: 1, scale: 1 },
  transition: { duration: 0.9, ease: EASE, delay: 0.2 },
};

export const cardReveal = (delay = 0, duration = 0.45) => ({
  initial: { opacity: 0, y: 20 },
  whileInView: { opacity: 1, y: 0 },
  viewport: VIEWPORT_40,
  transition: { duration, ease: EASE, delay },
});

export const cardRevealDeep = (delay = 0) => ({
  initial: { opacity: 0, y: 24 },
  whileInView: { opacity: 1, y: 0 },
  viewport: VIEWPORT_60,
  transition: { duration: 0.5, ease: EASE, delay },
});

export const slideIn = (x, delay = 0) => ({
  initial: { opacity: 0, x },
  whileInView: { opacity: 1, x: 0 },
  viewport: VIEWPORT_40,
  transition: { duration: 0.4, ease: EASE, delay },
});
